import { create } from 'zustand';
import { agenteService, type Agente } from '@/services/agenteService';

interface AgenteAtualState {
  agente: Agente | null;
  isLoading: boolean;
  error: string | null;
  fetchAgenteAtual: () => Promise<Agente | null>;
  setAgente: (agente: Agente | null) => void;
  limpar: () => void;
}

export const useAgenteAtualStore = create<AgenteAtualState>((set) => ({
  agente: agenteService.getAgenteCache(),
  isLoading: false,
  error: null,

  fetchAgenteAtual: async () => {
    set({ isLoading: true, error: null });
    const result = await agenteService.obterAgenteAtual();
    if ('failure' in result) {
      const error = result.failure.messages?.join(', ') || 'Erro ao obter agente';
      set({ isLoading: false, error });
      return null;
    }
    set({ agente: result.success, isLoading: false, error: null });
    return result.success;
  },

  setAgente: (agente) => set({ agente }),

  limpar: () => {
    agenteService.limparCache();
    set({ agente: null, error: null, isLoading: false });
  },
}));
